const FRONT_ORDER = [0, 1, 2, 3];
const BACK_LONG = [1, 0, 3, 2];
const BACK_SHORT = [2, 3, 0, 1];

function MiniCard({ card, side, rotate }) {
  if (!card) {
    return <div className="rounded-md border border-dashed border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/30" />;
  }
  return (
    <div
      className={`rounded-md border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-2.5 sm:p-3 overflow-hidden flex flex-col ${
        rotate ? "rotate-180" : ""
      }`}
    >
      <span className="text-[8px] font-bold uppercase tracking-widest text-slate-400">
        Karte {card.number} · {side === "front" ? "Vorne" : "Hinten"}
      </span>
      {side === "front" ? (
        <>
          <div className="mt-1 text-[11px] font-display font-bold text-slate-800 dark:text-slate-100 leading-tight line-clamp-2">
            {card.title}
          </div>
          <div className="mt-1 text-[9px] text-slate-500 dark:text-slate-400 leading-snug line-clamp-3">
            {card.question}
          </div>
        </>
      ) : (
        <>
          <div className="mt-1 text-[9px] text-slate-600 dark:text-slate-300 leading-snug line-clamp-4">
            {card.answer}
          </div>
          <div className="mt-auto flex items-center justify-between pt-1">
            <span className="text-[8px] font-mono text-slate-400 truncate">
              {card.citations?.map((n) => `(${n})`).join(" ")}
            </span>
            <span className="grid place-items-center h-5 w-5 rounded-sm bg-slate-200 dark:bg-slate-600 text-[6px] font-mono text-slate-600 dark:text-slate-200">
              QR
            </span>
          </div>
        </>
      )}
    </div>
  );
}

export function A4SheetPreview({ cards, side, flip }) {
  const group = cards.slice(0, 4);
  const order = side === "front" ? FRONT_ORDER : flip === "short" ? BACK_SHORT : BACK_LONG;
  const rotate = side === "back" && flip === "short";

  return (
    <div className="relative w-full max-w-xl mx-auto">
      <div className="relative grid grid-cols-2 grid-rows-2 gap-3 p-4 rounded-lg border border-slate-300 dark:border-slate-700 bg-slate-100 dark:bg-slate-900 shadow-inner aspect-[1.414/1]">
        {order.map((cardIdx, slot) => (
          <MiniCard key={slot} card={group[cardIdx]} side={side} rotate={rotate} />
        ))}
        {/* Schnittmarken */}
        <div className="pointer-events-none absolute left-1/2 top-0 bottom-0 border-l border-dashed border-slate-400/60 -translate-x-1/2" />
        <div className="pointer-events-none absolute top-1/2 left-0 right-0 border-t border-dashed border-slate-400/60 -translate-y-1/2" />
      </div>
      <p className="mt-2 text-center text-xs text-slate-500 dark:text-slate-400">
        A4 Querformat · 4× A6 · {side === "front" ? "Vorderseiten-Blatt" : "Rückseiten-Blatt (gespiegelt)"}
        {cards.length > 4 && ` · Blatt 1 von ${Math.ceil(cards.length / 4)}`}
      </p>
    </div>
  );
}
